import * as XLSX from "xlsx";

export default XLSX;